import React from "react";
import { createPortal } from "react-dom";
import "./Modal.scss";

const Modal = ({ title, children, onClose, className = '',style }) => {
    return createPortal(
        <div className="modal-overlay" onClick={onClose} style={style}>
            <div className={`modal-box animate__animated animate__fadeIn${className ? ` ${className}` : ''}`} onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <span className="modal-title">{title}</span>
                    <button className="modal-close" onClick={onClose}>
                        <span className="icon" data-icon="close" />
                    </button>
                </div>
                <div className="modal-body">
                    {children}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default Modal;
